<template>
    <div class="container">
    	<div class="row">
    		<v-calendar
				v-for="m in 12"
				:key="m"
				:from-page="{month: m, year: 2018}"
				:min-page="{month: m, year: 2018}"
				:max-page="{month: m, year: 2018}"
				:attributes="attrs">
			</v-calendar> 
    	</div>
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="card card-default">
                    <div class="card-header">Example Component</div>

                    <div class="card-body">
                        Alhamdulillah!
                        <!--<v-calendar :attributes="attrs"></v-calendar>
                        <test-component></test-component>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import Vue from 'vue/dist/vue.js'
	import VCalendar from 'v-calendar'
	import 'v-calendar/lib/v-calendar.min.css';
	import TestComponent from './TestComponent'
	Vue.use(VCalendar, {
	  formats: {
	    title: 'MMMM YYYY',
	    weekdays: 'W',
	    navMonths: 'MMM',
	    input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
	    dayPopover: 'L',
	  }
	})
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        data() {
		    return {
		      attrs: [
		        {
		          dates: [ new Date(2018, 8, 1),
		          	{ 
		          		start: new Date(2018, 9, 1), 
		          		end: new Date(2018, 9, 5) 
		          	},
		          	{ 
		          		start: new Date(2018, 9, 11), 
		          		end: new Date(2018, 9, 17)
		          	}
		          ],
		          highlight: {
		            backgroundColor: '#ff8080',
		          },
		          // Just use a normal style
		          contentStyle: {
		            color: '#fafafa',
		          },
		          themeStyles: {
		          	  headerTitle: "ok test"
			      },
		          // Our new popover here
		          popover: {
		            label: 'Claimed!',
		          }
		        }
		      ],
		    };
		},
		components: {
			TestComponent
		}
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ExampleComponent.vue